import { updateAllData } from './';
export const editTest = (
  test: any,
  phase: any,
  newDate: Date,
  tree: any,
  setTreeData: Function
) => {
  const clonePhases = JSON.parse(JSON.stringify(tree.phases));
  let cloneTest = { startDate: newDate.toString(), conflict: false };
  let index = -1;
  clonePhases[phase.phaseIndex].milestoneTests.forEach((currTest: any, idx: number) => {
    if ((currTest.name = test.name)) {
      cloneTest = JSON.parse(JSON.stringify(currTest));
      index = idx;
    }
  });

  cloneTest.startDate = newDate.toString();
  cloneTest.conflict = false;
  clonePhases[phase.phaseIndex].milestoneTests[index] = {
    ...clonePhases[phase.phaseIndex].milestoneTests[index],
    ...cloneTest,
  };

  updateAllData(tree, clonePhases, setTreeData);
};
